module.exports = __webpack_public_path__ + "static/media/work-img4.01472790.jpg";